import axiosClient from '@/lib/axios';
import { Metadata } from '@/types';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { VoteResultByShareholderType } from '../types';

type VoteResultsByShareholderResponse = {
  data: VoteResultByShareholderType[];
  metadata: Metadata;
};

const getVoteResultsByShareholder = async ({
  companyID,
  meetingID,
}: {
  companyID: number;
  meetingID?: number;
}): Promise<VoteResultsByShareholderResponse> => {
  const { data } = await axiosClient.get<VoteResultsByShareholderResponse>(
    `/companies/${companyID}/meetings/${meetingID}/meeting-points/resultsByShareholder?limit=1000`,
  );
  return data;
};

type QueryFnType = typeof getVoteResultsByShareholder;

type UseGetVoteResultsOptions = {
  config?: QueryFunction<QueryFnType>;
  companyID: number;
  meetingID?: number;
};

export const useGetVoteResultsByShareholder = ({ config, companyID, meetingID }: UseGetVoteResultsOptions) => {
  return useQuery({
    queryKey: ['vote', 'resultsByShareholder', companyID, meetingID],
    queryFn: () => getVoteResultsByShareholder({ companyID, meetingID }),
    ...config,
  });
};
